export default "__VITE_ASSET__BxJmeJgx__"